import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ResultModalRedeem } from '@app/enums';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface CobrandConfig {
  cobrandCode: string;
  bank: string;
  nameKey: string;
  cardNameKey: string;
  logo: string;
  includesCarryOn: boolean;
}

export interface TierBenefitConfig {
  tierCode: string;
  method: 'tier' | 'corporate';
  badgeLabel: string;
  badgeCssClass: string;
}

@Component({
  selector: 'app-bags-benefit-modal',
  templateUrl: './bags-benefit-modal.component.html',
  styleUrls: ['./bags-benefit-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class BagsBenefitModalComponent {
  @Input() cobrandConfig: CobrandConfig;
  @Input() hasCarryOnAlready = false;
  @Input() tierConfig: TierBenefitConfig | null = null;

  get showCarryOnBenefit(): boolean {
    return this.cobrandConfig?.includesCarryOn && !this.hasCarryOnAlready;
  }

  constructor(public modal: NgbActiveModal) {}

  onClose() {
    this.modal.close(ResultModalRedeem.NO_REDEEM);
  }

  onUseBenefit() {
    this.modal.close(ResultModalRedeem.SUCCESS);
  }
}
